<template>
  <div data-module="text_image_stack">
    <div class="main">
      <div class="content">
        <markdown class="markdown">{{data.content}}</markdown>
      </div>
    </div>
    <div class="aside">
      <img :src="data.image.src" :alt="data.image.alt">
    </div>
  </div>
</template>

<script>
export default {
  name: 'module_text_image_stack',
  props: ['data'],
};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';

$mobile-breakpoint: $breakpoint--default-mobile;

[data-module="text_image_stack"] {
  @include spacer();
  @include grid($rows: 2, $subgrid: true);

  .main {
    grid-column: 3 / span 6;
    grid-row: 2 / span 1;
  }

  .aside {
    grid-column: 1 / span 12;
    grid-row: 1 / span 1;
    display: flex;
    margin-bottom: 165px;
  }

  img {
    margin: 0 auto;
    max-width: 100%;
    align-self: flex-start;
  }

  @include mq($bp--tablet, 'down') {
    [data-module="text_image_stack"] {
      margin-bottom: 3rem;
    }

    .main {
      grid-column: 1 / span 12;
    }

    .aside {
      margin-bottom: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/text_image_stack.vue